module.exports = __webpack_public_path__ + "856aa8c6efde95f3447746161f6ad577.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-5.png
// module id = 2163
// module chunks = 0